module.exports = __webpack_public_path__ + "img/1455691941.76381c9c.jpg";